export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-gear/index.js